import { RootState } from '../store';
import { PLAYER_FSM_SLICE_KEY } from './player-fsm.constants';
import {
  playerSessionDetailAdapter,
  PlayerSessionDetailAdapterEntity,
} from './player-fsm.slice';

const selectors = playerSessionDetailAdapter.getSelectors(
  (state: RootState) =>
    state[PLAYER_FSM_SLICE_KEY].details ??
    playerSessionDetailAdapter.getInitialState(),
);

export const selectPlayerSessionDetailStates = selectors.selectEntities;

export const selectPlayerSessionDetailState = (state: RootState, id: string) =>
  selectors.selectById(state, id) as
    | PlayerSessionDetailAdapterEntity
    | undefined;
